export const aboutData = {
    title: "Who I am",
    description1: "Hello! My name is Muhammad Muzammal. I'm an aspiring web developer based in pakistan.",
    description2: "With 1.5 years of hands-on experience in ReactJS development, I'm the driving force behind captivating digital experiences at Power Information Technology Company. From dynamic user interfaces to seamless interactions, I specialize in leveraging React's power to turn ideas into reality. Let's collaborate and build something extraordinary!",
    image: 2
}